import React, { useEffect, useRef, useState } from "react";
import Icon from "../../assets/Icon";
import Lottie from "lottie-react";
import animationData from "../../assets/lotties/empty-lottie.json";
import Utils from "../utils/Utils";
import ReactTypingEffect from "react-typing-effect";

function LoginLeftSection({ interviewData, loginFormObj }) {
  const [showLottie, setShowLottie] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current) {
        if (containerRef.current.clientHeight > 450) {
          setShowLottie(false);
        } else if (containerRef.current.clientHeight < 450) {
          setShowLottie(true);
        }
      }
    };

    checkOverflow(); // Initial check
    window.addEventListener("resize", checkOverflow); // Recheck on window resize

    return () => window.removeEventListener("resize", checkOverflow);
  }, [containerRef]);
  const renderText = (text) => {
    // Split the text based on the "@" symbol
    const [jobTitle, company] = text.split(/@\s*(.+)/); // Split into job title and company

    return (
      <>
        <span className="text-primaryOrange">{jobTitle} </span>
        {company && <span>@{company}</span>} {/* Render company if it exists */}
      </>
    );
  };

  // console.log(interviewData)
  return (
    <div className="w-[95%] mx-auto flex justify-center items-center text-primaryWhite ">
      {interviewData ? (
        <div ref={containerRef} className=" ">
          <div className="flex flex-col gap-[0.45rem] max-w-[450px] lg:max-w-[500px] ">
            <div className="font-semibold text-[1.875rem] lg:text-[2rem] leading-[2.5rem] break-words">
              <span className="text-primaryOrange">
                {interviewData?.jobTitle}
              </span>{" "}
              @{interviewData?.companyName}
            </div>
            <div className="text-[#53A0F8] font-semibold text-[1.175rem] break-all mt-[0.2rem]">
              {loginFormObj?.interviewId}
            </div>
            <div className="text-[#FCFCFD] text-[0.96rem] flex items-center gap-[0.45rem] mt-[0.1rem] flex-wrap">
              <Icon type="clock" color="white" width="16" height="16" />
              <span className="text-gray-200"> Duration</span>
              <span className="font-semibold">
                {Utils.convertSecondsToTime(interviewData?.interviewTimer)}
              </span>
            </div>
            <div className="text-[#FCFCFD] text-[0.96rem] flex items-center gap-[0.45rem] flex-wrap">
              <Icon type="clock" color="white" width="16" height="16" />
              <span className="text-gray-200">Validity</span>
              <span className="font-semibold">
                {Utils.converToDateMonthYear(
                  interviewData?.interviewValidityDate
                )}{" "}
                {/* ({interviewData?.timeZone}) */}
              </span>
            </div>
          </div>
          {showLottie && (
            <div className="flex-col items-center hidden lg:flex">
              <Lottie
                animationData={animationData}
                loop
                style={{ maxWidth: "250px", width: "100%", height: "100%" }}
              />
              {/* <p>No interview scheduled.</p> */}
            </div>
          )}
          <div className="text-[0.96rem] break-word font-medium mt-4">
            Note: Start with this{"  "}
            <span
              onClick={() =>
                window.open(
                  "https://app.storylane.io/share/n4cm6wlaptkb",
                  "_blank"
                )
              }
              className="text-primaryOrange border-b-2 border-b-primaryOrange inline-block cursor-pointer"
            >
              interactive demo
            </span>
            {"  "} to get ready for the assessment. For best practices, check out
            this link:{" "}
            <span
              onClick={() =>
                window.open(
                  "https://blog.hireplusplus.com/ai-interview-guidelines-and-process/",
                  "_blank"
                )
              }
              className="text-primaryOrange border-b-2 border-b-primaryOrange inline-block cursor-pointer"
            >
              Best Practices Guide.
            </span>
          </div>
        </div>
      ) : (
        <div className="w-full">
          <div className="flex flex-col gap-[0.45rem] max-w-[400px] mx-auto lg:max-w-[500px] ">
            <div className="font-semibold text-[1.875rem] lg:text-[2rem] leading-[2.48rem] break-words">
              <span className="text-white ">
                <ReactTypingEffect
                  text={[
                    "Data Analyst @Google",
                    "Java Architect @Amazon",
                    "Program Manager @T Hub",
                  ]}
                  speed={100}
                  eraseSpeed={50}
                  eraseDelay={1500}
                  typingDelay={500}
                  cursor="|"
                  displayTextRenderer={(text) => renderText(text)}
                />
              </span>{" "}
            </div>
            <div className="text-[#53A0F8] font-semibold text-[1.175rem] break-all mt-[0.2rem]">
              SLOT_XX_XXXXXXX_XXXXXXX
            </div>
            <div className="text-[#FCFCFD] text-[0.96rem] flex items-center gap-[0.45rem] mt-[0.1rem] flex-wrap">
              <Icon type="clock" color="white" width="16" height="16" />
              <span className="text-gray-200"> Duration</span>
              <span className="font-semibold">30 minutes</span>
            </div>
            <div className="text-[#FCFCFD] text-[0.96rem] flex items-center gap-[0.45rem] flex-wrap">
              <Icon type="clock" color="white" width="16" height="16" />
              <span className="text-gray-200">Validity</span>
              <span className="font-semibold">18 XX 20XX (GMT)</span>
            </div>
          </div>
          <div className="flex-col items-center hidden lg:flex">
            <Lottie
              animationData={animationData}
              loop
              style={{ maxWidth: "300px", width: "100%", height: "100%" }}
            />
          </div>
          <div className="text-[0.96rem] break-word font-medium mt-4">
            Note: Start with this{"  "}
            <span
              onClick={() =>
                window.open(
                  "https://app.storylane.io/share/n4cm6wlaptkb",
                  "_blank"
                )
              }
              className="text-primaryOrange border-b-2 border-b-primaryOrange inline-block cursor-pointer"
            >
              interactive demo
            </span>
            {"  "} to get ready for the assessment. For best practices, check out
            this link:{" "}
            <span
              onClick={() =>
                window.open(
                  "https://blog.hireplusplus.com/ai-interview-guidelines-and-process/",
                  "_blank"
                )
              }
              className="text-primaryOrange border-b-2 border-b-primaryOrange inline-block cursor-pointer"
            >
              Best Practices Guide.
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default LoginLeftSection;
